import React from 'react';
import './gpj-theme.css';
import SiteHeader from './SiteHeader';
import Footer from './Footer';

export default function Layout({ currentView, setCurrentView, user, onLogout, children }) {
  return (
    <div className="App gpj min-h-screen relative">
      <SiteHeader
        currentView={currentView}
        setCurrentView={setCurrentView}
        user={user}
        onLogout={onLogout}
        showHomeContent={currentView === 'home'}
      />
      <main id="main-content">{children}</main>
      <Footer setCurrentView={setCurrentView} />
    </div>
  );
}
